import { bannerConstants } from '../_constants';

//-- get the list of banners
export function getBannersList(state = {}, action) {
  switch (action.type) {
    case bannerConstants.BANNER_LIST_REQUEST:
      return {
        getBannersList: false
      };

    case bannerConstants.BANNER_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { isGetAdvertismentList: true, getBannersList: action.successAction };

    case bannerConstants.BANNER_LIST_ERROR:
      return {
        getBannersList: false,
      };

    case bannerConstants.BANNER_SEARCH_REQUEST:
      return { isGetAdvertismentList: true, getBannersList: action.successAction.data };

    default:
      return state
  }
}

export function saveBanner(state = {}, action) {
  switch (action.type) {
    case bannerConstants.BANNER_ADDED_REQUEST:
      return {
        savedBanner: false
      };

    case bannerConstants.BANNER_ADDED_SUCCESS:
      //console.log("REDUCER ", action);
      return { savedBanner: action.successAction };

    case bannerConstants.BANNER_ADDED_FAILURE:
      return {
        savedBanner: false,
      };

    default:
      return state
  }
}



export function deleteBanner(state = {}, action) {
  switch (action.type) {
    case bannerConstants.BANNER_DELETE_REQUEST:
      return {
        deleteBanner: false
      };

    case bannerConstants.BANNER_DELETE_SUCCESS:
      //console.log("REDUCER ", action);
      return { deleteBanner: action.successAction };

    case bannerConstants.BANNER_DELETE_FAILURE:
      return {
        deleteBanner: false,
      };

    default:
      return state
  }
}


